<template>
    <CCard>
        <CCardHeader>
            <strong>Мы отправляли повторно курьера/консьержа по вине партнера?</strong>
        </CCardHeader>
        <CCardBody>
            <div class="overflow-hidden">
                <div class="flex items-center h-10 py-4">
                    <div>
                        <div style="display: flex">
                            <div sm="9">
                                <CInputCheckbox :checked.sync="order.partner_error" />
                            </div>
                            <div>Да</div>
                        </div>
                    </div>
                    <div class="w-3/12" style="margin-left: 30px">
                        <CButton color="primary" @click="updatePartnerError">Сохранить</CButton>
                    </div>
                </div>
            </div>
        </CCardBody>
    </CCard>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'OrderPartnerError',

        components: {},

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {},

        methods: {
            async updatePartnerError() {
                const value = Number(this.order.partner_error);

                try {
                    await Vue.axios.post(
                        `/orders/${this.order.id}/partner-error`,
                        { partner_error: value }
                    );

                    this.$root.$emit('showAlert', 'Успешно.');
                    location.reload();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },
        },
    };
</script>

<style lang="scss">

</style>
